import { dataColors } from "@/components/Charts/theme";

export const ANALYTICS_TABLE_PAGE_SIZE = 8;

/** Width reserved for the tick values and title of a labeled analytics Y-axis. */
export const ANALYTICS_LABELED_Y_AXIS_WIDTH = 80;

export const ANALYTICS_AUDIENCE_SCOPE_COLORS = [
  dataColors.primary,
  dataColors.green,
  dataColors.orange,
  dataColors.mint,
  dataColors.purple,
  dataColors.benchmark,
];
